/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Status_Creating_ProjectInputs */

const en_work_order_import_status_creating_project = /** @type {(inputs: Work_Order_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating project...`)
};

const fr_work_order_import_status_creating_project = /** @type {(inputs: Work_Order_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création du projet...`)
};

const de_work_order_import_status_creating_project = /** @type {(inputs: Work_Order_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt wird erstellt...`)
};

const it_work_order_import_status_creating_project = /** @type {(inputs: Work_Order_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creazione del progetto...`)
};

const ru_work_order_import_status_creating_project = /** @type {(inputs: Work_Order_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создание проекта...`)
};

const es_work_order_import_status_creating_project = /** @type {(inputs: Work_Order_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando proyecto...`)
};

const zh_cn2_work_order_import_status_creating_project = /** @type {(inputs: Work_Order_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建项目...`)
};

const ja_work_order_import_status_creating_project = /** @type {(inputs: Work_Order_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトを作成しています...`)
};

const hi_work_order_import_status_creating_project = /** @type {(inputs: Work_Order_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट तैयार हो रहा है...`)
};

const pt_pt2_work_order_import_status_creating_project = /** @type {(inputs: Work_Order_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criando projeto...`)
};

/**
* | output |
* | --- |
* | "Creating project..." |
*
* @param {Work_Order_Import_Status_Creating_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_status_creating_project = /** @type {((inputs?: Work_Order_Import_Status_Creating_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Status_Creating_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_import_status_creating_project(inputs)
	if (locale === "de") return de_work_order_import_status_creating_project(inputs)
	if (locale === "it") return it_work_order_import_status_creating_project(inputs)
	if (locale === "ru") return ru_work_order_import_status_creating_project(inputs)
	if (locale === "es") return es_work_order_import_status_creating_project(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_import_status_creating_project(inputs)
	if (locale === "ja") return ja_work_order_import_status_creating_project(inputs)
	if (locale === "hi") return hi_work_order_import_status_creating_project(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_import_status_creating_project(inputs)
	return en_work_order_import_status_creating_project(inputs)
});